import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { FilterContext } from '../../../shared/context/FilterContext';
import { ConfigurationContext } from '../../../shared/context/ConfigurationContext';
import { CommonCloudFirestore } from '../../../features/services/CommonCloudFirestore';
import { DOCUMENT_CONFIGURATION, LISTENER_CONFIGURATIONS } from '../../../shared/types/firestoreType';

import storageManager from '../../../shared/utility/storageManager';

import Header from './Header';
import Footer from './Footer';

import './styles.css';

export default function Index(props) {
    const navigate = useNavigate();
    const configurationsFirestore = new CommonCloudFirestore(DOCUMENT_CONFIGURATION);

    const [inputFilter, setInputFilter] = useState();
    const [configurations, setConfigurations] = useState({
        company: {},
        category: {}
    });

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        const configurations = await storageManager.fetch(LISTENER_CONFIGURATIONS, async () => await configurationsFirestore.getDocuments());
        var company = configurations.find(m => m.id === 'company') ?? {};
        var category = configurations.find(m => m.id === 'category') ?? {};
        setConfigurations({ company, category });
    }

    const onSearch = () => {
        filterContextConfig.setInputFilter(inputFilter);
        navigate(`/product-search`);
    };

    const ConfigurationContextConfig = {
        data: configurations,
        setData: (value) => { setConfigurations(value); }
    };

    const filterContextConfig = {
        inputFilter: inputFilter,
        setInputFilter: (value) => { setInputFilter(value); }
    };

    return (
        <ConfigurationContext.Provider value={ConfigurationContextConfig}>
            <FilterContext.Provider value={filterContextConfig}>
                <Header
                    setInputFilter={setInputFilter}
                    onSearch={onSearch} />
                <Outlet />
                <Footer />
            </FilterContext.Provider>
        </ConfigurationContext.Provider>
    );
}